import api from './api';

/**
 * TH-4 Three-Read Chorus — promote a divergent read into its own sub-trail.
 * Owner-strict + idempotent server-side; the returned root grows on the DAG via
 * the DIVERGENCE_PROMOTED WS reload (useReloadOnPeerEvent).
 */
export async function promoteDivergence(sessionId: string, messageId: string) {
  // NOTE: the axios client's baseURL already includes `/api` (like every sibling
  // in chatService), so the path is `/sessions/…` NOT `/api/sessions/…` — the
  // latter doubles to `/api/api/…` → 404 (caught by the TH-4 live promote e2e).
  const { data } = await api.post(`/sessions/${sessionId}/chorus/promote`, {
    message_id: messageId,
  });
  return data as { trail_root_message_id: string; trail_id: string; already: boolean };
}
